import dayjs from 'dayjs'

export const dayjsWithTz = (date?: dayjs.ConfigType) => {
  return dayjs(date).tz()
}
